import React from 'react';
import Sticky from 'react-stickynode';

const StickyElement = React.forwardRef((props, ref) => {
    const instanceRef = React.useRef(null);

    React.useImperativeHandle(ref, () => ({
        // react-stickynode only re-measures on scroll/resize events, so a
        // layout change with no such event leaves it with stale geometry.
        remeasure() {
            const instance = instanceRef.current;

            if (!instance || typeof instance.updateInitialDimension !== 'function') {
                return;
            }
            instance.scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
            instance.updateInitialDimension();
            instance.update();
        },
    }));

    return <Sticky ref={instanceRef} {...props} />;
});

StickyElement.displayName = 'StickyElement';

export default StickyElement;
